export type CatalogOption = {
  label: string
  value: string
}

type BackendCatalogItem = {
  id: number
  name: string
  isActive?: boolean
  createdAt?: string
  updatedAt?: string
}

type BackendResponse = {
  success: boolean
  message: string
  data: BackendCatalogItem[]
}

export function useCatalogs() {
  const cache = useState<Record<string, CatalogOption[]>>(
    'catalogs',
    () => ({})
  )

  async function getCatalog(name: string): Promise<CatalogOption[]> {
    const { $i18n } = useNuxtApp()
    if (cache.value[name]) return cache.value[name]

    const { data: catalogDataResponse } =
      await useApiFetchArray<BackendCatalogItem>(`/${name}`)

    const options: CatalogOption[] = [
      { label: $i18n.t('common.form_control.select_select'), value: "-1" },
      ...(catalogDataResponse.value?.data?.map(item => ({
        label: item.name,
        value: String(item.id)
      })) ?? [])
    ]

    cache.value[name] = options
    return options
  }

  /** Elimina una entrada del cache en memoria para forzar su recarga la
   *  proxima vez que se pida. Usado por invalidateCatalog(). */
  function clearByName(name: string) {
    if (name in cache.value) {
      const next = { ...cache.value }
      delete next[name]
      cache.value = next
    }
  }

  return { getCatalog, clearByName }
}
